<template>
  <div class="contact-page container">
    <div class="copyright-wrapper">
      <div class="contact-container">
        <div class="contact-header">
          <div class="contact-intro">
            <h1>Contact</h1>
            <p
              class="no-margin-left"
            >Whether you're a start up, established business or just looking to make contact, I'd love to hear from you. Feel free to write to me via the form below.</p>
          </div>
          <div class="contact-details">
            <div>
              <span>Location</span>Bali, Indonesia
            </div>
            <div>
              <span>Mobile</span>
              <a href="tel:+61406605715">+61 406 605 715 (whatsapp)</a>
            </div>
            <div>
              <span>Email</span>
              <a href="mailto:hello@williamsoo.com.au">hello@williamsoo.com.au</a>
            </div>
            <div>
              <span>Instagram</span>
              <a href="https://instagram.com/wsoo_photography">wsoo_photography</a>, 
              <a href="https://instagram.com/wsoo_mvmt">wsoo_mvmt</a>
            </div>
          </div>
        </div>
        <div class="contact-body">
          <form v-on:submit.prevent name="contact-form">
            <div class="contact-inputs">
              <span>
                <input type="text" name="name" v-model="user.name" placeholder="Full name*">
              </span>
              <span>
                <input type="email" name="email" v-model="user.email" placeholder="Email address*">
              </span>
            </div>
            <div>
              <span>
                <textarea name="message" v-model="user.message" placeholder="Your message*"></textarea>
              </span>
            </div>
            <input type="text" id="website" name="website">
            <transition name="fade">
              <div class="messageBox" v-show="messageAlert!==null">{{messageAlert}}</div>
            </transition>
            <button @keyup="validateForm" @click="handleSubmit" class="submit-button">Submit</button>
          </form>
        </div>
      </div>
      <div class="copyright">COPYRIGHT © {{getYear()}} WILLIAM SOO - GRAPHIC DESIGNER</div>
    </div>
  </div>
</template>
<script>
import ProjectWrapepr from "../components/project-wrapper.vue";
import axios from "axios";
import qs from "qs";

export default {
  data() {
    return {
      user: {
        email: "",
        name: "",
        message: "",
        website: "BCryptRequires22Chrcte",
      },
      messageAlert: null,
      validation: null,
    };
  },

  methods: {
    getYear() {
      return new Date().getFullYear();
    },
    validateForm() {
      const errors = [];
      if (!this.user.name) {
        errors.push("Name required. ");
      }
      if (!this.user.email) {
        errors.push("Email required. ");
      } else if (!this.validEmail(this.user.email)) {
        errors.push("Valid email required. ");
      }
      if (!this.user.message) {
        errors.push("Message required. ");
      }
      if (errors.length) {
        this.messageAlert = errors.join(" ");
        document.querySelector(".messageBox").style.backgroundColor = "";
        return;
      }
      this.messageAlert = null;
      return null;
    },
    handleSubmit() {
      if (this.validateForm() === null) {
        const self = this;
        axios
          .post("/mail.php", qs.stringify(this.user))
          .then(function(response) {
            document.querySelector(".messageBox").style.backgroundColor = "lightgreen";
            self.messageAlert = "Your message has been delivered, we will get back to you shortly!";
            this.user.email = "";
            this.user.message = "";
            this.user.name = "";

            setTimeout(() => {
              self.messageAlert = null;
            }, 3000);
          })
          .catch(function() {
            document.querySelector(".messageBox").style.backgroundColor = "";
            self.messageAlert = "Failed to send message, please try again later";
          });
      }
    },
    validEmail: function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
  },
  watch: {
    user: {
      handler() {
        if (this.messageAlert !== null) this.validateForm();
      },
      deep: true,
    },
  },
};
</script>


<style scoped>
.no-margin-left {
  margin-left: 0;
}
input,
textarea {
  margin-left: 0;
}
.copyright {
  position: static;
  font-size: 0.75rem;
  color: #fff;
  margin-top: 10px;
  padding-left: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

#website {
  display: none;
}
.messageBox {
  padding: 1rem;
  background-color: rgba(255, 0, 0, 0.5);
  margin: 10px 0;
}
input,
textarea {
  font-size: 14px;
  color: #333;
}
.contact-page {
  background: url("/assets/contact-bg.jpg") no-repeat center center;
  background-size: cover;
  width: 100%;
  padding: 1rem;
  margin-left: 90px;
  position: relative;
  height: 100%;
  box-sizing: border-box;
  transition: 0.8s all ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contact-container {
  background: white;
  width: 100%;
  height: 100%;
}

.contact-header {
  padding: 3.5rem 3rem 2rem 3rem;
  background-color: #313435;
  color: white;
  display: flex;
}
.contact-intro {
  padding-left: 0;
  width: 100%;
}
.contact-details {
  width: 460px;
  padding-left: 1rem;
}
.layout-sm .contact-details {
  padding-left: 0;
  width: 100%;
}

.contact-details a {
  color: #fff;
  text-decoration: none;
}
.contact-details span {
  width: 85px;
  font-weight: bold;
  display: inline-block;
}
h1 {
  margin: 0;
  text-transform: uppercase;
  position: relative;
}

h1::before {
  content: "";
  position: absolute;
  width: 30px;
  height: 3px;
  top: -1rem;
  background-color: #fff;
}

.contact-body {
  padding: 3rem;
}

.contact-body {
  padding: 3rem;
}

.contact-inputs {
  display: flex;
}
.contact-inputs input,
.contact-inputs span {
  width: 100%;
}
.contact-inputs input,
textarea {
  background-color: #e6e7e8;
  border: none;
  padding: 0.5rem;
  box-sizing: border-box;
}
.contact-inputs span:first-child {
  margin-right: 0.5rem;
}

textarea {
  width: 100%;
  margin-top: 1rem;
  min-height: 150px;
}
.submit-button {
  background-color: #313435;
  color: #fff;
  text-transform: uppercase;
  border: none;
  padding: 0.5rem;
  margin-left: 0;
}

form {
  background: none !important;
  border: none !important;
  margin: 0;
  padding: 0;
}
.layout-sm .contact-page,
.layout-md .contact-page {
  margin-left: 0;
}
.layout-sm .contact-page {
  display: block;
}
.layout-sm .contact-header,
.layout-sm .contact-inputs {
  flex-direction: column;
}

.layout-md .copyright-wrapper {
  margin-top: 135px;
  width: 80%;
}
.layout-sm .copyright-wrapper {
  margin-top: 135px;
  box-sizing: border-box;
  position: unset;
  transform: none;
  width: 100%;
}

.layout-sm .contact-intro p {
  margin: 5px 0;
}

.layout-xl .copyright-wrapper,
.layout-lg .copyright-wrapper {
  width: 80%;
  max-width: 1400px;
}
</style>
